// See: https://www.andiamo.co.uk/resources/iso-language-codes/
export enum ISO {
  AFG = 'AFG', // Afghanistan
  ALB = 'ALB', // Albania
  DZA = 'DZA', // Algeria
  ASM = 'ASM', // American Samoa
  AND = 'AND', // Andorra
  AGO = 'AGO', // Angola
  AIA = 'AIA', // Anguilla
  ATA = 'ATA', // Antarctica
  ATG = 'ATG', // Antigua and Barbuda
  ARG = 'ARG', // Argentina
  ARM = 'ARM', // Armenia
  ABW = 'ABW', // Aruba
  AUS = 'AUS', // Australia
  AUT = 'AUT', // Austria
  AZE = 'AZE', // Azerbaijan
  BHS = 'BHS', // Bahamas (the)
  BHR = 'BHR', // Bahrain
  BGD = 'BGD', // Bangladesh
  BRB = 'BRB', // Barbados
  BLR = 'BLR', // Belarus
  BEL = 'BEL', // Belgium
  BLZ = 'BLZ', // Belize
  BEN = 'BEN', // Benin
  BMU = 'BMU', // Bermuda
  BTN = 'BTN', // Bhutan
  BOL = 'BOL', // Bolivia (Plurinational State of)
  BES = 'BES', // Bonaire, Sint Eustatius and Saba
  BIH = 'BIH', // Bosnia and Herzegovina
  BWA = 'BWA', // Botswana
  BVT = 'BVT', // Bouvet Island
  BRA = 'BRA', // Brazil
  IOT = 'IOT', // British Indian Ocean Territory (the)
  BRN = 'BRN', // Brunei Darussalam
  BGR = 'BGR', // Bulgaria
  BFA = 'BFA', // Burkina Faso
  BDI = 'BDI', // Burundi
  CPV = 'CPV', // Cabo Verde
  KHM = 'KHM', // Cambodia
  CMR = 'CMR', // Cameroon
  CAN = 'CAN', // Canada
  CYM = 'CYM', // Cayman Islands (the)
  CAF = 'CAF', // Central African Republic (the)
  TCD = 'TCD', // Chad
  CHL = 'CHL', // Chile
  CHN = 'CHN', // China
  CXR = 'CXR', // Christmas Island
  CCK = 'CCK', // Cocos (Keeling) Islands (the)
  COL = 'COL', // Colombia
  COM = 'COM', // Comoros (the)
  COD = 'COD', // Congo (the Democratic Republic of the)
  COG = 'COG', // Congo (the)
  COK = 'COK', // Cook Islands (the)
  CRI = 'CRI', // Costa Rica
  HRV = 'HRV', // Croatia
  CUB = 'CUB', // Cuba
  CUW = 'CUW', // Curaçao
  CYP = 'CYP', // Cyprus
  CZE = 'CZE', // Czechia
  CIV = 'CIV', // Côte d'Ivoire
  DNK = 'DNK', // Denmark
  DJI = 'DJI', // Djibouti
  DMA = 'DMA', // Dominica
  DOM = 'DOM', // Dominican Republic (the)
  ECU = 'ECU', // Ecuador
  EGY = 'EGY', // Egypt
  SLV = 'SLV', // El Salvador
  GNQ = 'GNQ', // Equatorial Guinea
  ERI = 'ERI', // Eritrea
  EST = 'EST', // Estonia
  SWZ = 'SWZ', // Eswatini
  ETH = 'ETH', // Ethiopia
  FLK = 'FLK', // Falkland Islands (the) [Malvinas]
  FRO = 'FRO', // Faroe Islands (the)
  FJI = 'FJI', // Fiji
  FIN = 'FIN', // Finland
  FRA = 'FRA', // France
  GUF = 'GUF', // French Guiana
  PYF = 'PYF', // French Polynesia
  ATF = 'ATF', // French Southern Territories (the)
  GAB = 'GAB', // Gabon
  GMB = 'GMB', // Gambia (the)
  GEO = 'GEO', // Georgia
  DEU = 'DEU', // Germany
  GHA = 'GHA', // Ghana
  GIB = 'GIB', // Gibraltar
  GRC = 'GRC', // Greece
  GRL = 'GRL', // Greenland
  GRD = 'GRD', // Grenada
  GLP = 'GLP', // Guadeloupe
  GUM = 'GUM', // Guam
  GTM = 'GTM', // Guatemala
  GGY = 'GGY', // Guernsey
  GIN = 'GIN', // Guinea
  GNB = 'GNB', // Guinea-Bissau
  GUY = 'GUY', // Guyana
  HTI = 'HTI', // Haiti
  HMD = 'HMD', // Heard Island and McDonald Islands
  VAT = 'VAT', // Holy See (the)
  HND = 'HND', // Honduras
  HKG = 'HKG', // Hong Kong
  HUN = 'HUN', // Hungary
  ISL = 'ISL', // Iceland
  IND = 'IND', // India
  IDN = 'IDN', // Indonesia
  IRN = 'IRN', // Iran (Islamic Republic of)
  IRQ = 'IRQ', // Iraq
  IRL = 'IRL', // Ireland
  IMN = 'IMN', // Isle of Man
  ISR = 'ISR', // Israel
  ITA = 'ITA', // Italy
  JAM = 'JAM', // Jamaica
  JPN = 'JPN', // Japan
  JEY = 'JEY', // Jersey
  JOR = 'JOR', // Jordan
  KAZ = 'KAZ', // Kazakhstan
  KEN = 'KEN', // Kenya
  KIR = 'KIR', // Kiribati
  PRK = 'PRK', // Korea (the Democratic People's Republic of)
  KOR = 'KOR', // Korea (the Republic of)
  KWT = 'KWT', // Kuwait
  KGZ = 'KGZ', // Kyrgyzstan
  LAO = 'LAO', // Lao People's Democratic Republic (the)
  LVA = 'LVA', // Latvia
  LBN = 'LBN', // Lebanon
  LSO = 'LSO', // Lesotho
  LBR = 'LBR', // Liberia
  LBY = 'LBY', // Libya
  LIE = 'LIE', // Liechtenstein
  LTU = 'LTU', // Lithuania
  LUX = 'LUX', // Luxembourg
  MAC = 'MAC', // Macao
  MDG = 'MDG', // Madagascar
  MWI = 'MWI', // Malawi
  MYS = 'MYS', // Malaysia
  MDV = 'MDV', // Maldives
  MLI = 'MLI', // Mali
  MLT = 'MLT', // Malta
  MHL = 'MHL', // Marshall Islands (the)
  MTQ = 'MTQ', // Martinique
  MRT = 'MRT', // Mauritania
  MUS = 'MUS', // Mauritius
  MYT = 'MYT', // Mayotte
  MEX = 'MEX', // Mexico
  FSM = 'FSM', // Micronesia (Federated States of)
  MDA = 'MDA', // Moldova (the Republic of)
  MCO = 'MCO', // Monaco
  MNG = 'MNG', // Mongolia
  MNE = 'MNE', // Montenegro
  MSR = 'MSR', // Montserrat
  MAR = 'MAR', // Morocco
  MOZ = 'MOZ', // Mozambique
  MMR = 'MMR', // Myanmar
  NAM = 'NAM', // Namibia
  NRU = 'NRU', // Nauru
  NPL = 'NPL', // Nepal
  NLD = 'NLD', // Netherlands (the)
  NCL = 'NCL', // New Caledonia
  NZL = 'NZL', // New Zealand
  NIC = 'NIC', // Nicaragua
  NER = 'NER', // Niger (the)
  NGA = 'NGA', // Nigeria
  NIU = 'NIU', // Niue
  NFK = 'NFK', // Norfolk Island
  MNP = 'MNP', // Northern Mariana Islands (the)
  NOR = 'NOR', // Norway
  OMN = 'OMN', // Oman
  PAK = 'PAK', // Pakistan
  PLW = 'PLW', // Palau
  PSE = 'PSE', // Palestine, State of
  PAN = 'PAN', // Panama
  PNG = 'PNG', // Papua New Guinea
  PRY = 'PRY', // Paraguay
  PER = 'PER', // Peru
  PHL = 'PHL', // Philippines (the)
  PCN = 'PCN', // Pitcairn
  POL = 'POL', // Poland
  PRT = 'PRT', // Portugal
  PRI = 'PRI', // Puerto Rico
  QAT = 'QAT', // Qatar
  MKD = 'MKD', // Republic of North Macedonia
  ROU = 'ROU', // Romania
  RUS = 'RUS', // Russian Federation (the)
  RWA = 'RWA', // Rwanda
  REU = 'REU', // Réunion
  BLM = 'BLM', // Saint Barthélemy
  SHN = 'SHN', // Saint Helena, Ascension and Tristan da Cunha
  KNA = 'KNA', // Saint Kitts and Nevis
  LCA = 'LCA', // Saint Lucia
  MAF = 'MAF', // Saint Martin (French part)
  SPM = 'SPM', // Saint Pierre and Miquelon
  VCT = 'VCT', // Saint Vincent and the Grenadines
  WSM = 'WSM', // Samoa
  SMR = 'SMR', // San Marino
  STP = 'STP', // Sao Tome and Principe
  SAU = 'SAU', // Saudi Arabia
  SEN = 'SEN', // Senegal
  SRB = 'SRB', // Serbia
  SYC = 'SYC', // Seychelles
  SLE = 'SLE', // Sierra Leone
  SGP = 'SGP', // Singapore
  SXM = 'SXM', // Sint Maarten (Dutch part)
  SVK = 'SVK', // Slovakia
  SVN = 'SVN', // Slovenia
  SLB = 'SLB', // Solomon Islands
  SOM = 'SOM', // Somalia
  ZAF = 'ZAF', // South Africa
  SGS = 'SGS', // South Georgia and the South Sandwich Islands
  SSD = 'SSD', // South Sudan
  ESP = 'ESP', // Spain
  LKA = 'LKA', // Sri Lanka
  SDN = 'SDN', // Sudan (the)
  SUR = 'SUR', // Suriname
  SJM = 'SJM', // Svalbard and Jan Mayen
  SWE = 'SWE', // Sweden
  CHE = 'CHE', // Switzerland
  SYR = 'SYR', // Syrian Arab Republic
  TWN = 'TWN', // Taiwan (Province of China)
  TJK = 'TJK', // Tajikistan
  TZA = 'TZA', // Tanzania, United Republic of
  THA = 'THA', // Thailand
  TLS = 'TLS', // Timor-Leste
  TGO = 'TGO', // Togo
  TKL = 'TKL', // Tokelau
  TON = 'TON', // Tonga
  TTO = 'TTO', // Trinidad and Tobago
  TUN = 'TUN', // Tunisia
  TUR = 'TUR', // Turkey
  TKM = 'TKM', // Turkmenistan
  TCA = 'TCA', // Turks and Caicos Islands (the)
  TUV = 'TUV', // Tuvalu
  UGA = 'UGA', // Uganda
  UKR = 'UKR', // Ukraine
  ARE = 'ARE', // United Arab Emirates (the)
  GBR = 'GBR', // United Kingdom of Great Britain and Northern Ireland (the)
  UMI = 'UMI', // United States Minor Outlying Islands (the)
  USA = 'USA', // United States of America (the)
  URY = 'URY', // Uruguay
  UZB = 'UZB', // Uzbekistan
  VUT = 'VUT', // Vanuatu
  VEN = 'VEN', // Venezuela (Bolivarian Republic of)
  VNM = 'VNM', // Viet Nam
  VGB = 'VGB', // Virgin Islands (British)
  VIR = 'VIR', // Virgin Islands (U.S.)
  WLF = 'WLF', // Wallis and Futuna
  ESH = 'ESH', // Western Sahara
  YEM = 'YEM', // Yemen
  ZMB = 'ZMB', // Zambia
  ZWE = 'ZWE', // Zimbabwe
  ALA = 'ALA', // Åland Islands
}
